import { findConversation } from './findConversation';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import SortResults from 'owa-service/lib/contract/SortResults';
import constant from 'owa-service/lib/factory/constant';
import fieldURIOrConstantType from 'owa-service/lib/factory/fieldURIOrConstantType';
import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import isEqualTo from 'owa-service/lib/factory/isEqualTo';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import restrictionType from 'owa-service/lib/factory/restrictionType';
import RequestOptions from 'owa-service/lib/RequestOptions';

/*
 * This function makes a FindConversation server call to retrieve
 * the conversation data used to display the conversation in
 * list view for the given folder and conversationId.
 * The restriction only work in a normal non-search folder,
 * which means there are no viewfilter, focusedViewFilter,
 * hashtags, category, etc set.
 */
export default function findConversationEqualToConversationId(
    folderId: BaseFolderId,
    conversationId: string,
    sortResults: SortResults[],
    findConversationShapeName: string,
    options: RequestOptions
): Promise<FindConversationResponseMessage> {
    const idRestriction = isEqualTo({
        Item: propertyUri({ FieldURI: 'ConversationId' }),
        FieldURIOrConstant: fieldURIOrConstantType({
            Item: constant({
                Value: conversationId,
            }),
        }),
    });

    const retrictionType = restrictionType({
        Item: idRestriction,
    });

    const paging = indexedPageView({
        BasePoint: 'Beginning',
        MaxEntriesReturned: 1,
    });

    // restriction only work in a normal folder
    // therefore there should be no viewfilter, focusedViewFilter,
    // hashtags, category, etc set
    return findConversation(
        folderId,
        paging,
        'All',
        sortResults,
        FocusedViewFilter.None,
        findConversationShapeName,
        options,
        null /*categoryName*/,
        undefined /*ConversationQueryTraversal*/,
        null /*hashtagsToInclude*/,
        null /*hashtagsToExclude*/,
        null /*searchFolderId*/,
        retrictionType
    ).then((response: Response) => {
        return response.json().then(json => {
            return json.Body;
        });
    });
}
